module.exports = __webpack_public_path__ + "static/img/13.8db8f9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/包包/13.png
// module id = ejAz
// module chunks = 0